import React, { useEffect, useRef, useState } from "react";
import { Box, Tooltip } from "@mui/material";
import { MdKeyboardArrowDown, MdKeyboardArrowUp } from "react-icons/md";

const OBS_PRIMARY = "#1361a4";

/**
 * Célula de "Obs. Internas" usada nos comparativos (orçamento / negociação / fechamento).
 * Quando o texto excede a largura da coluna, exibe ellipsis + chevron para alternar
 * entre versão resumida e completa (a linha cresce verticalmente quando expandida),
 * e mostra um tooltip com o conteúdo completo ao passar o mouse no estado resumido.
 */
export function ObsCell({ value, baseSx }: { value: string; baseSx: Record<string, any> }) {
  const textRef = useRef<HTMLSpanElement>(null);
  const [hasOverflow, setHasOverflow] = useState(false);
  const [expanded, setExpanded] = useState(false);

  useEffect(() => {
    const el = textRef.current;
    if (el) setHasOverflow(el.scrollWidth > el.clientWidth + 1);
  }, [value]);

  return (
    <Box
      component="td"
      sx={{ ...baseSx, overflow: expanded ? "visible" : "hidden", whiteSpace: "nowrap" }}
    >
      <Box sx={{ display: "flex", alignItems: expanded ? "center" : "flex-start", gap: "4px" }}>
        <Tooltip
          title={hasOverflow && !expanded ? value : ""}
          placement="top"
          arrow
          enterDelay={400}
        >
          <Box
            component="span"
            ref={textRef}
            sx={{
              flex: 1,
              display: "block",
              overflow: expanded ? "visible" : "hidden",
              textOverflow: expanded ? "unset" : "ellipsis",
              whiteSpace: expanded ? "normal" : "nowrap",
              wordBreak: "break-word",
              fontSize: "inherit",
              fontFamily: "inherit",
              color: "inherit",
              lineHeight: "20px",
            }}
          >
            {value}
          </Box>
        </Tooltip>
        {hasOverflow && (
          <Box
            component="span"
            onClick={(e: React.MouseEvent) => {
              e.stopPropagation();
              setExpanded((p) => !p);
            }}
            sx={{
              flexShrink: 0,
              cursor: "pointer",
              color: OBS_PRIMARY,
              display: "flex",
              alignItems: "center",
              pt: "2px",
            }}
          >
            {expanded ? <MdKeyboardArrowUp size={14} /> : <MdKeyboardArrowDown size={14} />}
          </Box>
        )}
      </Box>
    </Box>
  );
}

export default ObsCell;
